module.exports = ($scope, $state, project, workflowSteps, adverseTermsLists) ->
  project.id = undefined
  project.related_project = $state.params.projectId
  project.related_project_type = 'cloned'
  $scope.adverseTermsLists = adverseTermsLists
  $scope.setProject(project)

  $scope.setWorkflows(workflowSteps)
  $scope.isCloneProject = true
